const e = "styles-module__search___aAvxQ", _ = "styles-module__hotel_name___El6Zz", s = "styles-module__header___psn9-", o = "styles-module__close___VFZrG", t = "styles-module__content___-TAXy", l = "styles-module__footer___ucaS7", c = {
  search: e,
  hotel_name: _,
  header: s,
  close: o,
  content: t,
  footer: l,
  "search-button": "styles-module__search-button___qEyXY",
  "gift-cards": "styles-module__gift-cards___f4Itg",
  "promo-code": "styles-module__promo-code___X6fC0",
  "search--full-screen": "styles-module__search--full-screen___g2AqI"
};
export {
  o as close,
  t as content,
  c as default,
  l as footer,
  s as header,
  _ as hotel_name,
  e as search
};
